module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-layout",
    class: [
      _vm.isHome ? 'is-home' : '',
      _vm.isHeaderHidden ? 'header-hidden' : '',
      _vm.isSideMenuOpen ? 'side-menu-open' : '',
      _vm.hasOverlays ? 'has-overlays' : ''
    ],
    attrs: {
      "id": "landing"
    }
  }, [_c('landing-header'), _vm._v(" "), _c('div', {
    staticClass: "view-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out"
    }
  }, [_c('router-view', {
    staticClass: "view"
  }, [_vm._t("default")], 2)], 1)], 1), _vm._v(" "), _c('landing-footer'), _vm._v(" "), _c('side-menu'), _vm._v(" "), _c('sitemap-overlay'), _vm._v(" "), _c('wechat-overlay')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61de39e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Landing.vue
// module id = 627
// module chunks = 1